import { render, staticRenderFns } from "./FormUploadvideo.vue?vue&type=template&id=f79c847a&scoped=true&"
import script from "./FormUploadvideo.vue?vue&type=script&lang=js&"
export * from "./FormUploadvideo.vue?vue&type=script&lang=js&"
import style0 from "./FormUploadvideo.vue?vue&type=style&index=0&id=f79c847a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79c847a",
  null
  
)

export default component.exports